import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-18531e11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-card raw-data-drawer-wrap" }
const _hoisted_2 = { class: "copy-button-icon-wrap" }
const _hoisted_3 = {
  key: "copy",
  class: "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  "aria-hidden": "true"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M85.333333 170.666667a85.333333 85.333333 0 0 1 85.333334-85.333334h426.666666a85.333333 85.333333 0 0 1 85.333334 85.333334v170.666666h170.666666a85.333333 85.333333 0 0 1 85.333334 85.333334v426.666666a85.333333 85.333333 0 0 1-85.333334 85.333334H426.666667a85.333333 85.333333 0 0 1-85.333334-85.333334v-170.666666H170.666667a85.333333 85.333333 0 0 1-85.333334-85.333334V170.666667z m341.333334 512v170.666666h426.666666V426.666667h-170.666666v170.666666a85.333333 85.333333 0 0 1-85.333334 85.333334h-170.666666z m170.666666-85.333334V170.666667H170.666667v426.666666h426.666666z",
  fill: "#fff"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: "check",
  class: "icon icon-check",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-hidden": "true"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M822.464 265.344a28.256 28.256 0 0 0-43.072 1.312l-352.96 417.664-181.92-212.992a28.288 28.288 0 0 0-43.104-1.088 37.12 37.12 0 0 0-0.96 48.256l204.096 238.944c5.76 6.752 13.696 10.56 22.016 10.56h0.096a29.088 29.088 0 0 0 22.048-10.656L823.68 313.6c11.52-13.728 11.008-35.328-1.216-48.256",
  fill: "#fff"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "raw-data-content" }

import { computed, onUnmounted, ref } from 'vue'
import { copyText } from '@/utils/tool'

const COPY_SUCCESS_MS = 2000


export default /*#__PURE__*/_defineComponent({
  __name: 'raw-data-drawer',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  rawData: {
    type: [Object, Array, String],
    default: () => ({})
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const copySuccess = ref(false)
let copySuccessTimer: ReturnType<typeof setTimeout> | null = null

const props = __props

const emits = __emit

const formattedData = computed(() => {
  if (typeof props.rawData === 'string') {
    try {
      return JSON.stringify(JSON.parse(props.rawData), null, 2)
    } catch {
      return props.rawData
    }
  }
  return JSON.stringify(props.rawData, null, 2)
})

function handleCopy() {
  copyText(formattedData.value)
  if (copySuccessTimer) {
    clearTimeout(copySuccessTimer)
    copySuccessTimer = null
  }
  copySuccess.value = true
  copySuccessTimer = setTimeout(() => {
    copySuccess.value = false
    copySuccessTimer = null
  }, COPY_SUCCESS_MS)
}

function handleClose() {
  emits('update:modelValue', false)
}

onUnmounted(() => {
  if (copySuccessTimer) {
    clearTimeout(copySuccessTimer)
    copySuccessTimer = null
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "model-value": __props.modelValue,
    title: _ctx.$t('listColumns.rawData'),
    "show-close": "",
    size: 850,
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_tooltip, {
          class: "item",
          effect: "light",
          content: copySuccess.value ? _ctx.$t('rawDataDrawer.copied') : _ctx.$t('rawDataDrawer.copy'),
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "copy-button",
              size: "mini",
              type: "primary",
              circle: "",
              onClick: handleCopy
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_Transition, {
                    name: "copy-icon",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (!copySuccess.value)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["content"]),
        _createElementVNode("pre", _hoisted_9, _toDisplayString(formattedData.value), 1)
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})